import { BaseState } from "./BaseState";
import { StateManager } from "../GameStateManager";
import { EulerStateManager } from "../EulerStateManager";
import { EulerStateEvents } from "../Consts";
import { EventData } from "../EventData";

class PostEventState extends BaseState<StateManager> {
  private resultsWaitTime = 7000;
  public id = "PostEventState"; // A unique identifier for the state

  constructor(stateManager: StateManager) {
    super(stateManager); // Pass the StateManager to the base class
    this.bindEvents();
    this.subscribeToEvents();
  }

  public onEnter(stateManager: StateManager): void {
    this.stateManager = stateManager;
    super.onEnter(stateManager); // Call the super method
    this.stateManager.enteredPostEventState();

    this.processEndOfEvent();
  }

  private processEndOfEvent() {
    const eventData = EventData.getInstance();
    if (eventData.wasEventCompletedMessageReceived()) {
      //we already got the complete message so no need to wait for it
      const eulerStateManager = EulerStateManager.getInstance();

      setTimeout(() => {
        eulerStateManager.changeState(eulerStateManager.eulerEventEndState);
      }, this.resultsWaitTime);
    }
  }

  private bindEvents() {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents() {
    const eulerStateManager = EulerStateManager.getInstance();
    eulerStateManager.subscribeToEvent(
      EulerStateEvents.ON_EVENT_END_STATE,
      this.transition,
    );
  }

  public transition(): void {
    this.stateManager?.changeState(this.stateManager.preEventGameState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { PostEventState };
